import { motion } from "framer-motion";
import { UserCircle, Gauge, Image, Search, Trophy, Inbox, ArrowRight } from "lucide-react";

const ITEMS = [
  [UserCircle, "Your player profile with a unique Player ID"],
  [Gauge, "Official, Assessment & Composite ratings"],
  [Image, "Download and share your Rating Card"],
  [Search, "Find players you've played with and rate them"],
  [Trophy, "Register for tournaments and track match history"],
  [Inbox, "Get organizer updates in your inbox"],
];

export const ForPlayers = ({ nav }) => (
  <section id="players" className="border-y grain" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid="for-players">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        <span className="text-xs tracking-[0.25em] uppercase font-bold text-primary-c">For Players · Free</span>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl mt-3">Your rating. <span className="text-primary-c">Verified.</span></h2>
        <p className="mt-4 text-sm sm:text-base max-w-lg" style={{ color: "var(--text-2)" }}>
          Create a free player account to build a rating that organizers trust — backed by real match results and verified community feedback.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <button data-testid="players-signup-cta" onClick={() => nav("/signup")} className="btn-glow rounded-full px-7 py-3.5 font-bold flex items-center gap-2">
            Create free player account <ArrowRight className="w-4 h-4" />
          </button>
          <button data-testid="players-login-cta" onClick={() => nav("/login")} className="glass rounded-full px-7 py-3.5 font-bold" style={{ color: "var(--text)" }}>Log in</button>
        </div>
      </motion.div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {ITEMS.map(([Icon, text], i) => (
          <motion.li key={text} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.06 }}
            className="rounded-2xl glass p-4 flex items-start gap-3 text-sm">
            <Icon className="w-5 h-5 text-primary-c shrink-0" /> {text}
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);
